var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSmileyWink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7883 32.0647C20.3048 34.5147 22.9675 36.1398 25.999 36.1398C29.0305 36.1398 31.6933 34.5147 33.2098 32.0647M21.2293 19.4999H16.8992M46.7992 25.9999C46.7992 37.4875 37.4867 46.7999 25.9992 46.7999C14.5117 46.7999 5.19922 37.4875 5.19922 25.9999C5.19922 14.5124 14.5117 5.19995 25.9992 5.19995C37.4867 5.19995 46.7992 14.5124 46.7992 25.9999ZM32.2392 19.4999H32.4234V19.6665H32.2392V19.4999Z",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmileyWink);
export default __webpack_public_path__ + "static/media/IconSmileyWink.2441c8cc1d357094eea1b0ae05957a8b.svg";
export { ForwardRef as ReactComponent };